// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IPlaidMetadataDto } from './IPlaidMetadataDto';
import {
    IPlaidMetadataDtoFromJSON,
    IPlaidMetadataDtoFromJSONTyped,
    IPlaidMetadataDtoToJSON,
    IPlaidMetadataDtoToJSONTyped,
} from './IPlaidMetadataDto';

/**
 * 
 * @export
 * @interface IPaymentAccountRequestDto
 */
export interface IPaymentAccountRequestDto {
    /**
     * 
     * @type {string}
     * @memberof IPaymentAccountRequestDto
     */
    payment_method_type?: IPaymentAccountRequestDtoPaymentMethodTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof IPaymentAccountRequestDto
     */
    is_default?: boolean;
    /**
     * 
     * @type {IPlaidMetadataDto}
     * @memberof IPaymentAccountRequestDto
     */
    plaid_metadata?: IPlaidMetadataDto;
    /**
     * 
     * @type {number}
     * @memberof IPaymentAccountRequestDto
     */
    account_id?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IPaymentAccountRequestDto
     */
    is_try_again_flow?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IPaymentAccountRequestDto
     */
    try_again_flow?: boolean;
}

/**
* @export
* @enum {string}
*/
export enum IPaymentAccountRequestDtoPaymentMethodTypeEnum {
    DIRECT_DEPOSIT = 'DIRECT_DEPOSIT',
    DEBIT = 'DEBIT',
    VENMO = 'VENMO',
    PAYPAL = 'PAYPAL',
    CHECK = 'CHECK'
}


/**
 * Check if a given object implements the IPaymentAccountRequestDto interface.
 */
export function instanceOfIPaymentAccountRequestDto(value: object): value is IPaymentAccountRequestDto {
    return true;
}

export function IPaymentAccountRequestDtoFromJSON(json: any): IPaymentAccountRequestDto {
    return IPaymentAccountRequestDtoFromJSONTyped(json, false);
}

export function IPaymentAccountRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPaymentAccountRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'payment_method_type': json['payment_method_type'] == null ? undefined : json['payment_method_type'],
        'is_default': json['is_default'] == null ? undefined : json['is_default'],
        'plaid_metadata': json['plaid_metadata'] == null ? undefined : IPlaidMetadataDtoFromJSON(json['plaid_metadata']),
        'account_id': json['account_id'] == null ? undefined : json['account_id'],
        'is_try_again_flow': json['isTryAgainFlow'] == null ? undefined : json['isTryAgainFlow'],
        'try_again_flow': json['try_again_flow'] == null ? undefined : json['try_again_flow'],
    };
}

export function IPaymentAccountRequestDtoToJSON(json: any): IPaymentAccountRequestDto {
    return IPaymentAccountRequestDtoToJSONTyped(json, false);
}

export function IPaymentAccountRequestDtoToJSONTyped(value?: IPaymentAccountRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'payment_method_type': value['payment_method_type'],
        'is_default': value['is_default'],
        'plaid_metadata': IPlaidMetadataDtoToJSON(value['plaid_metadata']),
        'account_id': value['account_id'],
        'isTryAgainFlow': value['is_try_again_flow'],
        'try_again_flow': value['try_again_flow'],
    };
}

